function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "1d5ilvpc2b",
  d: "M11.879 28c7.919-6.374 11.879-11.748 11.879-16.121C23.758 5.319 18.439 0 11.878 0 5.319 0 0 5.318 0 11.879 0 16.252 3.96 21.626 11.879 28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "krih9ssuxc",
  d: "M14 5.25h-1.875v-.625c0-1.063-.813-1.875-1.875-1.875h-2.5c-1.063 0-1.875.812-1.875 1.875v.625H4c-1.063 0-1.875.812-1.875 1.875v6.25c0 1.063.812 1.875 1.875 1.875h10c1.063 0 1.875-.813 1.875-1.875v-6.25c0-1.063-.813-1.875-1.875-1.875zm-6.875-.625c0-.375.25-.625.625-.625h2.5c.375 0 .625.25.625.625v.625h-3.75v-.625zm3.75 1.875V14h-3.75V6.5h3.75zm-7.5 6.875v-6.25c0-.375.25-.625.625-.625h1.875V14H4c-.375 0-.625-.25-.625-.625zm11.25 0c0 .375-.25.625-.625.625h-1.875V6.5H14c.375 0 .625.25.625.625v6.25z"
}), /*#__PURE__*/React.createElement("filter", {
  id: "lcnxw77kma",
  width: "188.4%",
  height: "175%",
  x: "-44.2%",
  y: "-26.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.188235294 0 0 0 0 0.309803922 0 0 0 0 0.996078431 0 0 0 0.502754692 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-870.000000, -598.000000) translate(876.000000, 601.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#lcnxw77kma)",
  xlinkHref: "#1d5ilvpc2b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#304FFE",
  xlinkHref: "#1d5ilvpc2b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-870.000000, -598.000000) translate(876.000000, 601.000000) translate(3.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "c0m4q6lqyd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#krih9ssuxc"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#c0m4q6lqyd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H18.18V18.18H0z"
}))))));
function SvgWorkPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPin);
export default __webpack_public_path__ + "static/media/work-pin.4743c75fa6d8ecd0b9487351b09beaec.svg";
export { ForwardRef as ReactComponent };